import * as Yup from 'yup';
import { TestContext } from 'yup';

const categoryCakeSchema = Yup.object().shape({
  labelEn: Yup.string().required('English Label is required.'),
  labelAr: Yup.string().required('Arabic Label is required.'),
  colorCode: Yup.string().required('Color Code is required.'),
  displayBackgroundColor: Yup.string().required('Background Code is required.'),
  // displayCss: Yup.string().required('Display CSS is required.'),
  displayMode: Yup.string().required('Display Mode is required.'),
  shapeId: Yup.string().required('Shape is required.'),
  flavorId: Yup.string().required('Flavor is required.'),
  toppingId: Yup.string().required('Topping is required.'),
  categoryId: Yup.string().required('Primary Category is required.'),
  additionalCategoryIds: Yup.array()
    .of(Yup.string())
    .default([])
    .test({
      name: 'no-duplicate-primary',
      message: 'Additional categories cannot include the primary category',
      test: function(this: TestContext, value: string[] | undefined) {
        const { categoryId } = this.parent as { categoryId: string };
        if (!value || !categoryId) return true;
        return !value.includes(categoryId);
      }
    })
    .test({
      name: 'unique-categories', 
      message: 'Additional categories must be unique',
      test: function(this: TestContext, value: string[] | undefined) {
        if (!value) return true;
        const uniqueValues = new Set(value);
        return uniqueValues.size === value.length;
      }
    }),
});

export default categoryCakeSchema;